<template>
  <b-card>
    <title-name />
    <notes-text />
    <expiry-date />
    <amount-price />
  </b-card>
</template>

<script>
import { BCard } from 'bootstrap-vue'
import TitleName from '@/views/Admin/Promissories/elements/Title.vue'
import NotesText from '@/views/Admin/Promissories/elements/Notes.vue'
import ExpiryDate from '@/views/Admin/Promissories/elements/Expiry_date.vue'
import AmountPrice from '@/views/Admin/Promissories/elements/Amount.vue'

export default {
  name: 'ItemForm',
  components: {
    BCard,
    TitleName,
    NotesText,
    ExpiryDate,
    AmountPrice,
  },
}
</script>
